var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2" }, [
      _c(
        "div",
        { staticStyle: { padding: "0" } },
        [
          _c(
            "b-form",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "12",
                    "label-cols-lg": "12"
                  }
                },
                [
                  _c("label", { staticClass: "font-weight-bold pt-0" }, [
                    _vm._v(_vm._s(_vm.$t("Valitse haluamasi tuotantomuoto")))
                  ]),
                  _vm._v(" "),
                  _vm.contract.CustomerType == 2
                    ? _c("b-form-radio-group", {
                        staticClass: "production-type",
                        attrs: {
                          stacked: "",
                          options: _vm.optionsCompany,
                          name: "production-method",
                          disabled: _vm.offerRequest
                        },
                        model: {
                          value: _vm.selected,
                          callback: function($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected"
                        }
                      })
                    : _c("b-form-radio-group", {
                        staticClass: "production-type",
                        attrs: {
                          stacked: "",
                          options: _vm.optionsConsumer,
                          name: "production-method",
                          disabled: _vm.offerRequest
                        },
                        model: {
                          value: _vm.selected,
                          callback: function($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }